import { RadioInput, RadioInputGroup, colors } from '@offerzen/pinata'
import ChevronDownIcon from '@offerzen/zenicon/ChevronDownIcon'
import AccessibleIcon from 'components/AccessibleIcon'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import styles from './styles'

const CurrencySelector = ({ currencies, setDisplayedCurrency, displayedCurrency }) => {
  const [showCurrencyModal, setShowCurrencyModal] = useState(false)

  const toggleCurrencySelector = () => {
    setShowCurrencyModal(!showCurrencyModal)
  }

  const selectCurrency = selectedValue => {
    const selectedCurrency = currencies.find(currency => currency.value === selectedValue)
    setDisplayedCurrency(selectedCurrency)
    setShowCurrencyModal(false)
  }

  return (
    <div className={styles.currencySelectorContainer}>
      <div className={styles.clickableContainer} onClick={toggleCurrencySelector}>
        Show salary in:
        <div className={styles.currencyInfo}>
          <span className={styles.currencyText}>{displayedCurrency.value}</span>
          <AccessibleIcon icon={ChevronDownIcon} size={14} color={colors.oxfordBlue} />
        </div>
      </div>
      {showCurrencyModal && (
        <div className={styles.currencyModal}>
          <RadioInputGroup value={displayedCurrency.value} onChange={e => selectCurrency(e.target.value)} hideLegend>
            {currencies.map(currency => (
              <RadioInput key={currency.value} value={currency.value} label={currency.label} />
            ))}
          </RadioInputGroup>
        </div>
      )}
    </div>
  )
}

CurrencySelector.propTypes = {
  setDisplayedCurrency: PropTypes.func,
  displayedCurrency: PropTypes.object,
  currencies: PropTypes.arrayOf(PropTypes.shape({})),
}

export default CurrencySelector
